module.exports = __webpack_public_path__ + "img/30.c5696f78.jpg";